import React, { FC } from 'react';
import AdjustFreeCreditsDialogView from './AdjustFreeCreditsDialogView';
import { useAdjustFreeCreditsDialogController } from '../../../controllers';
import { AdjustFreeCreditsDialogProps } from '../../../types';

const AdjustFreeCreditsDialog: FC<AdjustFreeCreditsDialogProps> = props => {
  const viewModel = useAdjustFreeCreditsDialogController(props);
  return <AdjustFreeCreditsDialogView {...viewModel} />;
};

export default AdjustFreeCreditsDialog;
